realmCommerceApp.controller("OrderController", OrderController);

/*@ngInject*/
function OrderController($uibModalInstance, orderService, messagesService, orderModel) {
    var vm = this;
    vm.orderModel = orderModel;
    vm.messagesService = messagesService;
    vm.orderMessageModel = {};

    vm.sendQueryOrderMessage = sendQueryOrderMessage;
    vm.cancel = cancel;

    activate();

    function activate() {
        vm.orderMessageModel = orderService.form.model;
        vm.orderMessageFields = orderService.form.fields;
    }

    function sendQueryOrderMessage() {
        $uibModalInstance.close();
        orderService.sendQueryOrderMessage(vm.orderModel.entity_id, vm.orderMessageModel.message).then(() => {
            vm.messagesService.success({'text': 'Query for order ' + vm.orderModel.order_reference + ' has been submitted'});
        });
    }

    function cancel() {
        $uibModalInstance.dismiss();
    }
}


// WEBPACK FOOTER //
// ./static/js/app/order/order.controller.js